/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ otp: NonNullable<unknown> }} Email_Otp_SubjectInputs */

const th_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} คือรหัสเข้าใช้งาน Remy Sport ของคุณ`)
};

const en_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} is your Remy Sport code`)
};

const ja_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} — Remy Sport の認証コード`)
};

const zh_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} 是你的 Remy Sport 验证码`)
};

const es_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} es tu código de Remy Sport`)
};

const pt_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} é o seu código do Remy Sport`)
};

const id_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} adalah kode Remy Sport Anda`)
};

const fr_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} est votre code Remy Sport`)
};

const tl_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} ang Remy Sport code mo`)
};

const vi_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} là mã Remy Sport của bạn`)
};

const ko_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp}은(는) 회원님의 Remy Sport 코드입니다`)
};

const de_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} ist dein Remy-Sport-Code`)
};

const ru_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} — ваш код Remy Sport`)
};

const tr_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} Remy Sport kodunuz`)
};

const it_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} è il tuo codice Remy Sport`)
};

const pl_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} to twój kod Remy Sport`)
};

const uk_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} — ваш код Remy Sport`)
};

const hi_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} आपका Remy Sport कोड है`)
};

const ar_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} هو رمزك في Remy Sport`)
};

const ms_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} ialah kod Remy Sport anda`)
};

const bn_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} আপনার Remy Sport কোড`)
};

const zh_tw2_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} 是你的 Remy Sport 驗證碼`)
};

const zh_hk2_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} 是你的 Remy Sport 驗證碼`)
};

const ur_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} آپ کا Remy Sport کوڈ ہے`)
};

const fa_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} کد Remy Sport شماست`)
};

const sw_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} ndio msimbo wako wa Remy Sport`)
};

const nl_email_otp_subject = /** @type {(inputs: Email_Otp_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.otp} is je Remy Sport-code`)
};

/**
* | output |
* | --- |
* | "{otp} is your Remy Sport code" |
*
* @param {Email_Otp_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_otp_subject = /** @type {((inputs: Email_Otp_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Otp_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_otp_subject(inputs)
	if (locale === "ja") return ja_email_otp_subject(inputs)
	if (locale === "zh") return zh_email_otp_subject(inputs)
	if (locale === "es") return es_email_otp_subject(inputs)
	if (locale === "pt") return pt_email_otp_subject(inputs)
	if (locale === "id") return id_email_otp_subject(inputs)
	if (locale === "fr") return fr_email_otp_subject(inputs)
	if (locale === "tl") return tl_email_otp_subject(inputs)
	if (locale === "vi") return vi_email_otp_subject(inputs)
	if (locale === "ko") return ko_email_otp_subject(inputs)
	if (locale === "de") return de_email_otp_subject(inputs)
	if (locale === "ru") return ru_email_otp_subject(inputs)
	if (locale === "tr") return tr_email_otp_subject(inputs)
	if (locale === "it") return it_email_otp_subject(inputs)
	if (locale === "pl") return pl_email_otp_subject(inputs)
	if (locale === "uk") return uk_email_otp_subject(inputs)
	if (locale === "hi") return hi_email_otp_subject(inputs)
	if (locale === "ar") return ar_email_otp_subject(inputs)
	if (locale === "ms") return ms_email_otp_subject(inputs)
	if (locale === "bn") return bn_email_otp_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_otp_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_otp_subject(inputs)
	if (locale === "ur") return ur_email_otp_subject(inputs)
	if (locale === "fa") return fa_email_otp_subject(inputs)
	if (locale === "sw") return sw_email_otp_subject(inputs)
	if (locale === "nl") return nl_email_otp_subject(inputs)
	return en_email_otp_subject(inputs)
});